import { type FC, memo, useMemo } from 'react';

import type { Props } from '@/components/select/StaffSelect/types';
import useStaff from '@/hooks/useStaff';
import AutocompleteSingleSelect from '@/ui/components/AutocompleteSingleSelect';
import Spinner from '@/ui/components/Spinner';
import setStaffSelectValue from '@/utils/formatStaffAsSelectOption';

const StaffSelect: FC<Props> = ({
  label,
  onChange,
  placeholder = 'Select Staff',
  selectedOption,
  filter = { withKustomerId: true }
}) => {
  const { data, isPending } = useStaff(filter);

  const staffOptions = useMemo(() => {
    return (
      data?.data?.map((staff) => {
        return setStaffSelectValue(staff);
      }) ?? []
    );
  }, [data?.data]);

  return isPending ? (
    <Spinner label="Loading staff" />
  ) : (
    <AutocompleteSingleSelect
      label={label}
      onChange={onChange}
      options={staffOptions}
      placeholder={placeholder}
      selectedOption={selectedOption}
    />
  );
};

export default memo(StaffSelect);
